module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Katherine Hall Page\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Katherine Hall Page’s first mystery, "), _c('I', [_vm._v("The Body in the Belfry")]), _vm._v(", won an Agatha Award for Best First Mystery Novel. The fifteenth in the series, "), _c('I', [_vm._v("The Body in the Snowdrift")]), _vm._v(", won the Agatha Award for Best Mystery Novel. Page was also awarded the Agatha for Best Short Story for \"The Would-Be Widower\" in the Malice Domestic X collection. She was an Edgar nominee for her juvenile mystery, "), _c('I', [_vm._v("Christie & Company Down East")]), _vm._v(". "), _c('I', [_vm._v("The Body in the Lighthouse")]), _vm._v(" was one of three nominees for The Mary Higgins Clark Award.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17PlRqq/tc-custom/9781466806603.jpg?1731838271254",
      "alt": "This image is the cover for the book Body in the Bouillon, The Faith Fairchild Series"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Body in the Bouillon, The Faith Fairchild Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A minister’s wife is determined to find out who’s preying on the residents of a New England retirement home in this acclaimed cozy mystery series.")]), _c('br'), _c('br'), _vm._v("Minister’s wife, sometime sleuth, and culinary artist Faith Sibley Fairchild is intrigued by rumors of mysterious doings at Hubbard House—an elegant, secluded retirement home for the well-heeled Yankees of Aleford, Massachusetts. Determined to do some surreptitious snooping, she joins the pricey retreat’s flu-depleted kitchen staff, only to witness an aging resident collapse face-first into a bowl of Faith’s hot and savory bouillon."), _c('br'), _c('br'), _vm._v("Faith barely has time to ponder the suspicious death before a blackmailing drug dealer turns up dead in her bedroom! Now one thing is clear to the amateur investigator: murder doesn’t just happen at Hubbard—it’s the house specialty. And Faith’s own demise might very well be the next item on the menu.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0